import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { isProblemDetails, ProblemDetails } from '@core/models/problem-details';
import { MessageService } from 'primeng/api';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((responseError: HttpErrorResponse) => {
      const problemDetails = getProblemDetails(responseError);

      messageService.add({
        severity: 'error',
        summary: problemDetails.title,
        detail: problemDetails.detail,
      });

      return throwError(() => responseError);
    }),
  );
};

const getProblemDetails = (responseError: HttpErrorResponse): ProblemDetails => {
  if (responseError.status === 401) {
    return {
      title: 'Log in required',
      detail: 'Your session has expired. Please log in again.',
      status: 401,
      type: 'https://httpstatuses.com/401',
    };
  }

  if (responseError.error && isProblemDetails(responseError.error)) {
    return responseError.error;
  }

  if (400 <= responseError.status && responseError.status < 500) {
    return {
      title: 'Client Error',
      detail: 'A client error occurred.',
      status: responseError.status,
      type: 'https://httpstatuses.com/' + responseError.status,
    };
  } else if (responseError.status >= 500) {
    return {
      title: 'Server Error',
      detail: 'An unexpected error occurred on the server.',
      status: responseError.status,
      type: 'https://httpstatuses.com/' + responseError.status,
    };
  }

  console.error('Unknown error:', responseError);
  return {
    title: 'Unknown error occurred',
    detail: 'An unexpected error occurred.',
    status: responseError.status,
    type: 'https://httpstatuses.com/' + responseError.status,
  };
};
